import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthClassicEmailSent() {
	return <AuthShell variant="classic"><AuthForm variant="classic" mode="email-sent" /></AuthShell>;
}

export default AuthClassicEmailSent;
